import React from "react";
import Row from "./Row";

export default function AddressRow({label, lines}) {
  return <Row label={label}>{lines.map((line, index) => <p key={index}>{line}</p>)}</Row>
}